<template>
  <div class="pop" @touchmove.prevent v-if="popShow">
    <div class="pop-coupon">
      <div class="pop-coupon-top">
        <span>请输入优惠券码，进行兑换</span>
        <i @click="onClose">
          <img src="https://file.40017.cn/appresource/image/voucher/v-close.png" alt="">
        </i>
      </div>
      <div class="pop-coupon-bottom">
        <input type="text" v-model="couponNum" placeholder="请输入优惠券码">
        <div class="btn" :class="{ 'btn-normal': couponNum }" @click="exchange">兑换</div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Field } from 'vant';
export default {
  name: 'pop',
  props: {
    popShow: {
      type: Boolean,
      default: false
    },
  },
  components: {
    // [Field.name]: Field
  },
  data() {
    return {
      couponNum: ''
    }
  },
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    onClose() {
      this.couponNum = ''
      this.$emit('onClose')
    },
    exchange() {
      if (this.couponNum) {
        this.$emit('exchange', this.couponNum)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, .7);

  &-coupon {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    height: 155px;
    margin: 0 38px;
    background: #FFFFFF;
    border-radius: 12px;
    overflow: hidden;

    &-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 26px;
      margin: 0 15px;
      margin-top: 16px;

      span {
        margin-left: 5px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 26px;
      }

      i {
        display: inline-block;
        width: 22px;
        height: 22px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    &-bottom {
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      width: 270px;
      height: 50px;
      margin: 0 16px;
      margin-top: 20px;
      background: #F6F6F6;
      border-radius: 10px;

      input {
        width: 143px;
        height: 22px;
        margin-left: 14px;
        margin-top: 15px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999;
        line-height: 22px;
        border: none;
        background: #F6F6F6;
      }


      .btn {
        position: absolute;
        right: 30px;
        top: 57%;
        transform: translateY(-57%);
        width: 69px;
        height: 34px;
        margin-right: 8px;
        background: #06C584;
        border-radius: 22px;
        opacity: 0.4;
        line-height: 34px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
      }

      .btn-normal {
        opacity: 1;
      }
    }
  }
}</style>
